var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 87 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8279 85.527L46.8284 85.5274C53.4782 91.7103 64.301 86.9942 64.301 77.9249V12.7914C64.301 3.70597 53.4778 -0.991507 46.8297 5.17364L46.3775 5.59304V5.62231L29.1895 21.617C26.7624 22.5966 24.9449 24.5787 24.1362 26.9763H19.9757C9.81692 26.9763 1.58682 35.2062 1.58682 45.365C1.58682 55.5239 9.81691 63.7539 19.9757 63.7539H24.136C24.9436 66.1506 26.759 68.1445 29.1919 69.1153L46.8279 85.527Z",
    fill: "#FFC700",
    stroke: "#FA05E1",
    strokeWidth: 2.82637
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2515 15.7195C76.1782 15.7195 73.664 18.2137 73.664 21.307V69.4649C73.664 72.5382 76.1581 75.0524 79.2515 75.0524C82.3248 75.0524 84.839 72.5582 84.839 69.4649V21.307C84.839 18.2337 82.3448 15.7195 79.2515 15.7195Z",
    fill: "#FFC700",
    stroke: "#FA05E1",
    strokeWidth: 2.82637
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.2f88c62ce985f17292e83ad2efce9506.svg";
export { ForwardRef as ReactComponent };